module.exports = __webpack_public_path__ + "ath_game_web/img/9.2.5d1698e9.png";